import React from 'react';

import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import { Route, Switch } from 'react-router-dom';
import './App.css';
import myAccount from './components/myAccount';
import hoc from './components/hoc/protectedRoute'
import Terms from './components/docs/terms'
import RecurringTerms from './components/docs/recurringTerms'
import DocusignBridge from './components/ui/docuSignBridge';

function App() {
  return (
    <div className="App">

      <Switch>
        <Route exact path="/" component={hoc(myAccount)} />
        <Route exact path="/member/:memberId" component={hoc(myAccount)} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/recurring-payment-terms" component={RecurringTerms} />
        <Route exact path="/docusign-bridge" component={DocusignBridge} />
      </Switch>
    </div>
  );
}
export default withRouter(App);
